import type { NavigateOptions } from '@reach/router';
import { navigate } from 'gatsby';
import { isIOS } from './mobileUserAgent';

type SafeNavigateOptionsType = Record<string, unknown>;

export const safeNavigate = (to: string, options?: NavigateOptions<SafeNavigateOptionsType>): void => {
    if (typeof window === 'undefined') {
        navigate(to, options);

        return;
    }

    if (!isIOS()) {
        navigate(to, options);

        return;
    }

    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(
            () => {
                navigate(to, options);
            },
            { timeout: 100 }
        );
    } else {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                navigate(to, options);
            });
        });
    }
};
